import React from "react"

import Layout from "../components/layout"

const IndexPage = () => (
  <Layout>
    <div className="contact-form__container">
      <div className="contact-form">
        <div className="contact-form__header">
          <h1>FILL OUT THE FORM AND WE WILL GET BACK TO YOU!</h1>
          <p>It’s only possible to become wholeseller in UK for now. We will soon be available in US, and EU.</p>
        </div>

        <form
          name="Contact Form"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          action="/thank-you"
        >
          <input type="hidden" name="form-name" value="Contact Form" />
          <p class="hidden">
            <label>Don’t fill this out if you’re human: <input name="bot-field" /></label>
          </p>

          <div>
            <label>First Name</label>
            <input type="text" name="first_name" />
          </div>

          <div>
            <label>Last Name</label>
            <input type="text" name="last_name" />
          </div>

          <div>
            <label>Your Email</label>
            <input type="email" name="email" />
          </div>

          <h2>Business Details</h2>

          <div>
            <label>Company/Studio</label>
            <input type="text" name="company" />
          </div>

          <div>
            <label>Address</label>
            <input type="text" name="address" />
          </div>

          <div>
            <label>City</label>
            <input type="text" name="city" />
          </div>

          <div>
            <label>Country</label>
            <input type="text" name="country" />
          </div>

          <div>
            <label>Phone</label>
            <input type="tel" name="number" />
          </div>

          <div>
            <label>Instagram Handle</label>
            <input type="text" name="Instagram" />
          </div>

          <div>
            <label>Number of artists</label>
            <input type="number" name="Artists" />
          </div>

          <div>
            <label>Website (if applicable) </label>
            <input type="text" name="Website" />
          </div>

          <div>
            <span>*Currently available for UK studios only. US and EU are coming soon!</span>
          </div>

          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  </Layout>
)

export default IndexPage
